module.exports = __webpack_public_path__ + "assets/img/tongue-attack.b9dbe56f.png";